"use client";
import React, { useEffect, useState } from "react";
import Images from "@src/images";

export default function SVGSpriteClient() {
  const [svgContent, setSvgContent] = useState<string>("");
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadSVG = async () => {
      try {
        const response = await fetch(Images.iconSprite);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const text = await response.text();
        if (!text.includes("<svg") && !text.includes("<defs")) {
          throw new Error("Invalid SVG content");
        }

        setSvgContent(text);
        setIsLoaded(true);
      } catch (error) {
        console.error("SVG sprite loading failed:", error);
        try {
          const fallbackResponse = await fetch("/public/icons.svg");
          if (fallbackResponse.ok) {
            const text = await fallbackResponse.text();
            setSvgContent(text);
            setIsLoaded(true);
          }
        } catch (fallbackError) {
          console.error("Fallback also failed:", fallbackError);
        }
      }
    };

    void loadSVG();
  }, []);

  return svgContent ? (
    <div
      style={{ display: "none" }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
      data-svg-sprite-loaded={isLoaded}
    />
  ) : null;
}
